<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <div class="col-sm-12">
          <div class="row">
            <div class="col-sm-8">
              <label>Journals</label>
              <select id="lstJournals" class="form-control" multiple onchange="$('#btnGetVolumeIssues').trigger('click');">
                <option *ngFor="let item of journalList" value={{item.ID}}>
                  {{item.Acronym}}
                </option>
              </select>
            </div>
            <div class="col-sm-2">
              <label>Volume</label>
              <select id="lstVolume" class="form-control">
                <option selected value="0">All</option>
                <option *ngFor="let item of volumeList" value={{item.ID}}>
                  {{item.Volume}}
                </option>
              </select>
            </div>
            <div class="col-sm-2">
              <label>Issue</label>
              <select id="lstIssue" class="form-control">
                <option selected value="0">All</option>
                <option *ngFor="let item of issueList" value={{item.ID}}>
                  {{item.Issue}}
                </option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-2">
              <label>From</label>
              <input type="date" name="DOB" class="form-control float-right" id="Txt_FromDate" autocomplete="off">
            </div>
            <div class="col-sm-2">
              <label>To</label>
              <input type="date" name="DOB" class="form-control float-right" id="Txt_ToDate" autocomplete="off">
            </div>
            
            <div class="col-sm-2">
              <button type="button" class="btn btn-outline-info waves-effect waves-light clsMargin" title="Get" (click)="getFiltered()">Search</button>
              <button type="button" class="btn btn-outline-danger waves-effect waves-light clsMargin" title="Clear" (click)="resetFilter()" style="margin-left:10px">Reset</button>
            </div>
          </div>
        </div>

        <table #dataTable class="display" style="width:100%" id="transactionTable"></table>
        <button type="button" id="btnPopupDT" (click)="showDetails()" style="display:none">Show</button>
        <button type="button" id="btnUploadDT" (click)="showUpload()" style="display:none">Upload</button>
        <button type="button" id="btnDownloadDT" (click)="download()" style="display:none">Download</button>
        <button type="button" id="btnStart" (click)="start()" style="display:none">Start</button>
        <button type="button" id="btnStartConfirm" (click)="startConfirm()" style="display:none">Start Confirm</button>
        <button type="button" id="btnLoadList" (click)="getTransationList()" style="display:none">Get</button>
        <button type="button" id="btnGetVolumeIssues" (click)="getVolumeIssue()" style="display:none">GetVolumeIssue</button>

        <!--<button type="button" id="ddlNextProcess" (click)="checkNextProcess()" style="display:none">CheckNextProcess</button>-->

        <div id="divArticleInfo" class="modal" [style.display]="showModal ? 'block' : 'none'">
          <div class="modal-dialog modal-xl custome-modal">
            <div class="modal-content" id="modal_contentArt">
              <div class="modal-header">
                <h4 class="modal-title">Article Details</h4>
                <button type="button" class="close" data-dismiss="modal" (click)="hide()">×</button>
              </div>
              <div class="modal-body">
                <app-articleinfo></app-articleinfo>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hide()">Close</button>
              </div>
            </div>
          </div>
        </div>

        <div id="divFileUpload" class="modal" [style.display]="showFileUpload ? 'block' : 'none'">
          <div class="modal-dialog modal-md">
            <div class="modal-content">
              <div class="modal-header">
                <h3 class="modal-title">Upload package?</h3>
                <button type="button" class="close" data-dismiss="modal" (click)="hide()">×</button>
              </div>
              <div class="modal-body">
                <form id="submitFile">
                  <div class="form-group">
                    <div class="row">
                      <div class="col-sm-4">
                        <h5>Article: {{uploadTitle}}</h5>
                      </div>
                      <div class="col-sm-4">
                        <h5>Transaction Status: {{status}}</h5>
                      </div>
                      <div class="col-sm-4">
                        <h5>Transaction Process: {{processName}}</h5>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="row">
                      <div class="col-sm-12">
                        Remarks<em id="astric">*</em>
                        <input id="txt_Remarks" type="text" class="form-control" maxlength="40" />
                      </div>
                    </div>
                  </div>
                  <!--<div class="form-group">
                    <div class="row">
                      <div class="col-sm-12">
                        Next Process<em>*</em>
                        <select class="form-control select2" id="ddlProcess" onchange="$('#ddlNextProcess').trigger('click');">
                        </select>
                      </div>
                    </div>
                  </div>-->
                  <div class="form-group">
                    <div id="LoadingImagePopup">
                      <img src="../../assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="form-group" id="fileSelection">
                          <h5> Choose File for this package: {{uploadTitle}}</h5>
                          <h5>Selected file: {{selectedFile}}</h5>
                        </div>
                        <div class="form-group">
                          <div class="row" style="margin-bottom: 15px;">
                            <!--<div class="col-md-12" style="text-align: center">
                              <input type="file" #file placeholder="Choose file" (change)="selectUploadFile(file.files)" style="display: none;">
                              <button type="button" class="btn btn-success" id="btnAddFile" (click)="file.click()">Add File</button>
                              <button type="button" class="btn btn-success" (click)="Submit()">Submit</button>
                            </div>-->
                            <div class="col-md-12" style="text-align: center">
                              <input type="file" #fileUpload placeholder="Choose file" (change)="uploadFile(fileUpload.files)" style="display:none;">
                              <button type="button" class="btn btn-outline-info waves-effect waves-light" id="btnCorrection" (click)="correctionTransaction()">Correction</button>
                              <button type="button" class="btn btn-outline-info waves-effect waves-light" id="btnComplete" (click)="fileUpload.click()" style="margin: 0px 10px 0px 10px">Complete</button>
                              <button type="button" class="btn btn-outline-info waves-effect waves-light" id="btnHOld" (click)="holdTransaction()">Hold</button>
                            </div>
                            <div class="col-md-12">
                              <span class="upload" id="spanProgress" *ngIf="progress > 0">
                                {{progress}}%
                              </span>
                              <span class="upload" id="spanUploadMsg" *ngIf="message">
                                {{message}}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div id="divCorrection" class="modal">
          <div class="modal-dialog modal-md">
            <div class="modal-content">
              <div class="modal-header">
                <h3 class="modal-title">Correction Transaction</h3>
                <button type="button" class="close" data-dismiss="modal" (click)="hideTransaction()">x</button>
              </div>
              <div class="modal-body">
                <form>
                  <div class="form-group" id="fileSelectionDiv">
                    <h5> Choose File for this package: {{uploadTitle}}</h5>
                    <h5>Selected file: {{selectedFile}}</h5>
                  </div>
                  <div class="modal-footer">
                    <input type="file" #file placeholder="Choose file" (change)="selectUploadFile(file.files)" style="display: none;">
                    <button type="button" class="btn btn-outline-info waves-effect waves-light" id="btnAddFile" (click)="file.click()" style="margin: 0px 10px 0px 10px">Add File</button>
                    <button type="button" class="btn btn-outline-success waves-effect waves-light" (click)="submit()">Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
